export default "__VITE_ASSET__BM$LDuve__"